import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';  // Existing styles - KEEP THIS FIRST
import './styles/tailwind.css';  // Tailwind - ADD THIS SECOND
import './lib/api';  // Configure axios (CSRF, withCredentials, base URL) before any UI request
import { clearLegacyStoryPreference } from './lib/landingPages';
import App from './App';

// The landing choice moved from a localStorage flag to the user profile
// (issue #250); drop the superseded key so it can't look like a second setting.
clearLegacyStoryPreference();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
